export default "__VITE_ASSET__daf4fbde__"